import { Button, Grid, Hidden } from "@material-ui/core";
import React from "react";

import error404Image from "../../assets/images/error-404.png";
import appIosSaludsa from "../../assets/images/app-saludsa-link.svg";
import appAndroidSaludsa from "../../assets/images/google-paly-app-saludsa.svg";
import appHuaweiSaludsa from "../../assets/images/app-saludsa-app-gallery.svg";
import wpImageBlue404 from "../../assets/images/whatsapp_blue_404.svg";
import wpImageGreen404 from "../../assets/images/whatsapp_green_404.svg";
import julianError404 from "../../assets/images/julian-404.png";
import styles from "./styles";

export const Error404 = () => {
  const classes = styles();

  return (
    <Grid container spacing={3} className={classes.mainContainer}>
      <Grid item sm={12} md={6}>
        <div className={classes.infoContainer}>
          <div className={classes.titleError404}>Oops!</div>
          <div className={classes.subtitleError404}>
            La página que estás buscando fue movida o ya no existe.
          </div>
          <Hidden mdUp>
            <Grid item md={12}>
              <img
                src={julianError404}
                alt="julian-404"
                style={{ width: "100%" }}
              />
            </Grid>
          </Hidden>
          <div className={classes.descriptionError404}>
            Por favor verifica la URL o puedes regresar al inicio. <br />
            <br />
            Si estas buscando un producto de medicina prepagada o si eres
            cliente y necesitas contactarnos:
          </div>
          <div className={classes.infoButtonContainer}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
            >
              Chat ventas
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
            >
              Servicio al cliente
            </Button>
          </div>
        </div>
        <div className={classes.appInfoContainer}>
          <img
            src={error404Image}
            alt={"error-404-telefono"}
            className={classes.error404Image}
          />
          <div>
            <div className={classes.titleAppSaludsa}>
              Descarga la App Saludsa
            </div>
            <Hidden xsDown>
              <div>
                <a
                  href="https://apps.apple.com/ec/app/salud-sa/id1276866377"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={appIosSaludsa}
                    alt="app-saludsa-ios"
                    className={classes.buttonAppMargin}
                  />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.saludsa.central&hl=es&gl=US"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={appAndroidSaludsa}
                    alt="app-saludsa-android"
                    className={classes.buttonAppMargin}
                  />
                </a>
                <a
                  href="https://appgallery.huawei.com/#/app/C102050729"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={appHuaweiSaludsa} alt="app-saludsa-huawei" />
                </a>
              </div>
            </Hidden>
          </div>
          <hr className={classes.lineAppContainer} />
        </div>
        <Hidden smUp>
          <div className={classes.phoneLinksAppContainer}>
            <a
              href="https://apps.apple.com/ec/app/salud-sa/id1276866377"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={appIosSaludsa}
                alt="app-saludsa-ios"
                className={classes.buttonAppMargin}
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.saludsa.central&hl=es&gl=US"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={appAndroidSaludsa}
                alt="app-saludsa-android"
                className={classes.buttonAppMargin}
              />
            </a>
            <a
              href="https://appgallery.huawei.com/#/app/C102050729"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={appHuaweiSaludsa} alt="app-saludsa-huawei" />
            </a>
          </div>
        </Hidden>

        <div>
          <div className={classes.wpContainer}>
            <img src={wpImageBlue404} alt="app-saludsa-huawei" />
            <div className={classes.telfContainer}>Llámanos al: 026020920</div>
          </div>
          <div className={classes.wpContainer}>
            <img src={wpImageGreen404} alt="app-saludsa-huawei" />
            <div className={classes.telfContainer}>Llámanos al: 026020920</div>
          </div>
        </div>
      </Grid>
      <Hidden smDown>
        <Grid item xs={6} sm={6}>
          <img
            src={julianError404}
            alt="julian-404"
            style={{ width: "100%" }}
          />
        </Grid>
      </Hidden>
    </Grid>
  );
};
